export default __webpack_public_path__ + "static/media/rp_1.35ade81d.png";